export default {
	yandexMaps: () => {
		return importExt( 'https://api-maps.yandex.ru/2.1/?apikey=9a0c9307-a513-41a7-a704-3b08dbdbae9d&lang=ru_RU' )
			.then( () => {
				return new Promise( ( fnResolve ) => {
					ymaps.ready( () => {
						fnResolve( ymaps );
					} );
				} );
			} );
	},
		googleMaps: () => {
		return new Promise( ( fnResolve ) => {
			window.gmLoad = () => {
				fnResolve( google.maps );
			}
			return importExt( 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDKW3vDDnV-RtKm9_M8yRv98RAIV44lER0&callback=gmLoad&sensor=false' );
		} );
	},
	jquery: () => {
		return import( /* webpackChunkName: "jquery" */ 'jquery/dist/jquery.js' )
			.then( ( jQuery ) => {
				window.$ = window.jQuery = jQuery.default;
				return jQuery.default;
			} );
	}
};